import { Pipe, PipeTransform } from '@angular/core';

// This directive converts 123456789 to 1 2 3 4 5 6 7 8 9
// https://jhalabi.com/blog/accessibility-phone-number-formatting
@Pipe({
  name: 'rdAriaPhoneNumber',
})
export class AriaPhoneNumberPipe implements PipeTransform {
  transform(phoneNumber: string): string {
    // Split string into array to allow replacements per character.
    const phoneNumberArray = phoneNumber.split('');

    const ariaReadablePhoneNumber = phoneNumberArray.map((char, index) => {
      // Append a space if a number is succeeded by another number.
      // This is to let the screen reader read "1 2" with a space as opposed to just "12" where it's just fast.
      if (/^\d$/.test(char) && /^\d$/.test(phoneNumberArray[index + 1])) {
        return `${char} `;
      }

      // Change spaces and close parens to a period. This makes the screen reader slow down a bit to clearly separate area code and phone number.
      if ([' ', ')'].includes(char)) {
        return `. `;
      }

      // Remove open parens. No need to read an open paren.
      if (['('].includes(char)) {
        return ``;
      }

      return char;
    });

    return ariaReadablePhoneNumber.join('').trim();
  }
}
